var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from 'react';
import compose from 'recompose/compose';
import { injectIntl, FormattedNumber } from 'react-intl';
import WithValidation from '../../lib/WithValidation';
import Icon from '../../components/Icon';
import PropTypes from 'prop-types';
import Translate from '../../components/Translate';
import translate from '../../lib/utils/translate';

var ConfirmContactInfo = function (_Component) {
  _inherits(ConfirmContactInfo, _Component);

  function ConfirmContactInfo() {
    _classCallCheck(this, ConfirmContactInfo);

    return _possibleConstructorReturn(this, (ConfirmContactInfo.__proto__ || Object.getPrototypeOf(ConfirmContactInfo)).apply(this, arguments));
  }

  _createClass(ConfirmContactInfo, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          username = _props.username,
          email = _props.email,
          phone = _props.phone,
          callingCode = _props.callingCode,
          fullname = _props.fullname,
          birthdate = _props.birthdate,
          address = _props.address,
          zip = _props.zip,
          city = _props.city,
          optins = _props.optins,
          onSubmit = _props.onSubmit,
          onGoBack = _props.onGoBack,
          currency = _props.currency,
          intl = _props.intl,
          gender = _props.gender,
          limitsData = _props.limitsData;


      return React.createElement(
        'form',
        { className: 'Step3 form', onSubmit: onSubmit },
        React.createElement(
          'div',
          { className: 'account-information' },
          React.createElement(
            'div',
            { className: 'account-header' },
            React.createElement(Icon, { icon: 'user-circle' }),
            React.createElement(
              'p',
              { className: 'username' },
              username
            )
          ),
          React.createElement(
            'div',
            { className: 'user-info' },
            React.createElement(
              'b',
              null,
              fullname
            ),
            React.createElement(
              'p',
              null,
              address,
              ' ',
              zip
            ),
            React.createElement(
              'p',
              null,
              city
            )
          ),
          React.createElement(
            'div',
            { className: 'birth-info' },
            React.createElement(
              'p',
              null,
              gender
            ),
            React.createElement(
              'p',
              null,
              birthdate
            )
          ),
          React.createElement(
            'div',
            { className: 'contact-info' },
            React.createElement(
              'p',
              null,
              React.createElement(Icon, { icon: 'phone' }),
              ' ',
              '+' + callingCode + phone
            ),
            React.createElement(
              'p',
              null,
              React.createElement(Icon, { icon: 'envelope' }),
              ' ',
              email
            )
          )
        ),
        optins && React.createElement(
          'div',
          { className: 'optin-information-holder' },
          React.createElement(
            'div',
            { className: 'optin-information-wrapper' },
            React.createElement(
              'p',
              null,
              React.createElement(
                'strong',
                null,
                translate({
                  id: 'label.optin-message-step3-before',
                  defaultMessage: 'You have opted in to receive direct marketing'
                }, intl)
              )
            ),
            React.createElement(
              'p',
              null,
              translate({
                id: 'label.optin-message-step3-after',
                defaultMessage: 'To stay updated with our promotions and offers, it is recommended that you stay subscribed.'
              }, intl)
            )
          ),
          React.createElement(
            'p',
            { className: 'final-message' },
            translate({
              id: 'label.optin-message-step3-last',
              defaultMessage: 'Click previous below, if you would like to change your selection.'
            }, intl)
          )
        ),
        limitsData && limitsData.map(function (l) {
          var period = '';

          switch (parseInt(l.Timespan)) {
            case 0:
              period = translate({ id: 'label.each_transaction' }, intl);
              break;
            case 1:
              period = translate({ id: 'label.each_day' }, intl);
              break;
            case 7:
              period = translate({ id: 'label.each_week' }, intl);
              break;
            case 30:
              period = translate({ id: 'label.each_month' }, intl);
              break;
            default:
              break;
          }

          return React.createElement(
            'div',
            { className: 'inner-limit-info', key: Math.random() },
            React.createElement(
              'p',
              null,
              React.createElement(Icon, { icon: 'dollar-sign' }),
              React.createElement(Translate, {
                defaultMessage: 'type',
                id: 'label.type.' + l.Type
              }),
              ', ',
              period,
              ' -',
              ' ',
              React.createElement(FormattedNumber, {
                value: l.Amount,
                style: 'currency',
                currency: currency
              })
            )
          );
        }),
        React.createElement(
          'div',
          { className: 'buttons-wrapper' },
          React.createElement(
            'div',
            { className: 'backButton layout-item-6 promo-button' },
            React.createElement(Icon, { icon: 'angle-left' }),
            React.createElement(
              'a',
              { className: 'wide', onClick: onGoBack },
              translate({ id: 'action.button.previous' }, intl)
            )
          ),
          React.createElement(
            'div',
            { className: 'layout-item-6 promo-button' },
            React.createElement(
              'button',
              { className: 'button primary wide', type: 'submit' },
              translate({ id: 'action.button.activate_account' }, intl)
            )
          )
        )
      );
    }
  }]);

  return ConfirmContactInfo;
}(Component);

ConfirmContactInfo.propTypes = {
  username: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.string,
  callingCode: PropTypes.string,
  fullname: PropTypes.string,
  birthdate: PropTypes.string,
  address: PropTypes.string,
  zip: PropTypes.string,
  city: PropTypes.string,
  optins: PropTypes.bool,
  onSubmit: PropTypes.func,
  onGoBack: PropTypes.func,
  currency: PropTypes.string,
  intl: PropTypes.object,
  gender: PropTypes.string,
  limitsData: PropTypes.array
};


var rules = {};

export default compose(WithValidation(rules), injectIntl)(ConfirmContactInfo);